import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const OfficeCard = ({ 
  office, 
  onEdit, 
  onDelete, 
  onView, 
  isSelected, 
  onSelect, 
  isDragging = false,
  dragHandleProps = {},
  showDragHandle = true 
}) => {
  const handleEdit = (e) => {
    e?.stopPropagation();
    onEdit(office);
  };

  const handleDelete = (e) => {
    e?.stopPropagation();
    onDelete(office);
  };

  const handleView = (e) => {
    e?.stopPropagation();
    onView(office);
  };

  const handleSelect = (e) => {
    e?.stopPropagation();
    onSelect(office?.id);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'text-success bg-success/10';
      case 'inactive':
        return 'text-muted-foreground bg-muted';
      case 'pending':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div 
      className={`bg-card border border-border rounded-lg p-4 transition-all duration-200 hover:shadow-elevation-2 ${
        isDragging ? 'opacity-50 rotate-2 scale-105' : ''
      } ${isSelected ? 'ring-2 ring-primary' : ''}`}
    >
      <div className="flex items-start space-x-4">
        {/* Drag Handle */}
        {showDragHandle && (
          <div 
            {...dragHandleProps}
            className="flex-shrink-0 mt-2 cursor-grab active:cursor-grabbing p-1 hover:bg-muted rounded"
          >
            <Icon name="GripVertical" size={16} className="text-muted-foreground" />
          </div>
        )}

        {/* Selection Checkbox */}
        <div className="flex-shrink-0 mt-2">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={handleSelect}
            className="w-4 h-4 text-primary bg-background border-border rounded focus:ring-primary focus:ring-2"
          />
        </div>

        {/* Profile Image */}
        <div className="flex-shrink-0">
          <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted">
            <Image
              src={office?.profileImage}
              alt={office?.profileImageAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Office Details */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-semibold text-foreground truncate font-arabic">
                {office?.name}
              </h3>
              <p className="text-sm text-primary font-medium mt-1">
                {office?.title}
              </p>
              <p className="text-sm text-muted-foreground mt-1">
                {office?.department}
              </p>
            </div>

            {/* Status Badge */}
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(office?.status)}`}>
              {office?.status === 'active' && 'نشط'}
              {office?.status === 'inactive' && 'غير نشط'}
              {office?.status === 'pending' && 'معلق'}
            </span>
          </div>

          {/* Contact Information */}
          <div className="mt-3 space-y-1">
            {office?.email && (
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Mail" size={14} />
                <span className="truncate">{office?.email}</span>
              </div>
            )}
            {office?.phone && (
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Phone" size={14} />
                <span>{office?.phone}</span>
              </div>
            )}
          </div>

          {/* Description */}
          {office?.description && (
            <p className="text-sm text-muted-foreground mt-2 line-clamp-2">
              {office?.description}
            </p>
          )}

          {/* Action Buttons */}
          <div className="flex items-center space-x-2 mt-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleView}
              iconName="Eye"
              iconPosition="left"
              iconSize={14}
            >
              عرض
            </Button>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={handleEdit}
              iconName="Edit"
              iconPosition="left"
              iconSize={14}
            >
              تحرير
            </Button>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDelete}
              iconName="Trash2"
              iconPosition="left"
              iconSize={14}
              className="text-error hover:text-error hover:bg-error/10"
            >
              حذف
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeCard;